import { render, staticRenderFns } from "./HistoryOrderModal.vue?vue&type=template&id=4f2bd9c6&scoped=true"
import script from "./HistoryOrderModal.vue?vue&type=script&lang=ts"
export * from "./HistoryOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./HistoryOrderModal.vue?vue&type=style&index=0&id=4f2bd9c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2bd9c6",
  null
  
)

export default component.exports